module.exports = __webpack_public_path__ + "static/media/give-away.7ae37438.png";